/* auto-generated: @mui/icons-material */
import Base from '@mui/icons-material/Check';
import {withMuiAdapter} from '@common/icons/with-mui-adapter';

export const CheckIcon = withMuiAdapter(Base, 'Check');
